import { shallowEqual, useSelector } from "react-redux";
import moment from 'moment';
import { getTaskListAPI } from "src/api/ScheduleTaskApi";
import SelectDropDown from "src/components/SelectDropDown";
const ScheduleTaskFilter = ({
  search,
  setSearch,
  assignee,
  setAssignee,
  taskId,
  setTaskId,
  activeTab,
}) => {
  const {
    search: { data = [] } = {},
    taskCompletionStatus = [],
    taskSkipStatus = [],
  } = useSelector((state) => state.ScheduleTaskReducer, shallowEqual);

  const dayMap = {
    0: "SU",
    1: "M",
    2: "T",
    3: "W",
    4: "TH",
    5: "F",
    6: "SA",
  };

  const today = moment().format("YYYY-MM-DD");
  const todayDayChar = dayMap[moment().day()];

  // 1. Get subTaskIds that are completed today
  const completedTodaySet = new Set(
    taskCompletionStatus
      .filter((t) => moment(t.date).format("YYYY-MM-DD") === today)
      .map((t) => t.subTaskId?.toString())
  );
  const skippedTodaySet = new Set(
    taskSkipStatus
      .filter(t => moment(t.date).format('YYYY-MM-DD') === today)
      .map(t => t.subTaskId?.toString())
  );
  // 2. Filter data by today's char and not completed
  const filteredData = data.filter((task) => {
    const taskId = task._id?.toString();
    const isToday = (task.selectedDays || []).includes(todayDayChar);
    const isCompleted = completedTodaySet.has(taskId);
    const isSkipped = skippedTodaySet.has(taskId);

    return isToday && (activeTab === "all" || (!isCompleted && !isSkipped));
  });

  // 3. Collect unique assignees
  const uniqueUsersMap = new Map();
  filteredData.forEach((task) => {
    (task.users || []).forEach((user) => {
      if (!uniqueUsersMap.has(user._id)) {
        uniqueUsersMap.set(user._id, {
          id: user._id,
          name: `${user.firstName} ${user.lastName}`,
        });
      }
    });
  });

  const assigneeOptions = Array.from(uniqueUsersMap.values());
  return (
    <div className="row mb-3">
      <div className="col-md-3 mb-2">
        <input
          type="text"
          className="form-control"
          placeholder="Search Task..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="col-md-3 mb-2">
        <SelectDropDown
          api={getTaskListAPI}
          displayKey="taskName"
          valueKey="_id"
          value={taskId}
          onChange={
            (value, item) => {
              setTaskId(value || null)
            }
          }
          placeholder="Select Project"
        />
      </div>
      <div className="col-md-3 mb-2">
        <select
          className="form-select"
          value={assignee}
          onChange={(e) => setAssignee(e.target.value)}
        >
          <option value="">All Assignees</option>
          <option value="Self">Self</option>
          {/*<option value="Other">Other</option> */}
          {assigneeOptions.sort((a, b) => a.name.localeCompare(b.name)).map(user => (
            <option key={user.id} value={user.id}>{user.name}</option>
          ))}
        </select>
      </div>
      {/* {activeTab === 'all' && (
      <div className="col-md-6 text-end">
        <button
          className="btn btn-outline-secondary"
          onClick={() => setShowHierarchyModal(true)}
        >
          Manage Task Hierarchy
        </button>
      </div>
      )} */}
    </div>
  )
}
export default ScheduleTaskFilter